/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { useSelector } from 'react-redux';
import Decimal from 'decimal.js';

const standardError =
  '* estimate has a relative standard error of 25% to 50% and should be used with caution';
const standardErrorHigh =
  '** estimate has a relative standard error greater than 50% and is considered too unreliable for general use';

export default function Annotation() {
  const curData = useSelector((state) => state.data.curData);
  const incomeSelectActive = useSelector(
    (state) => state.data.incomeSelectActive,
  );
  const type = useSelector((state) => state.data.type);
  const sex = useSelector((state) => state.data.sex);
  const incomeLevel = useSelector((state) => state.data.incomeLevel);
  const earnLess = useSelector((state) => state.data.earnLess);
  const earnMore = useSelector((state) => state.data.earnMore);
  const timeframe = useSelector((state) => state.data.timeframe);
  const totalInGroup = useSelector((state) => state.data.totalInGroup);

  const indicatorIndex = curData.findIndex((d) => d.iID === incomeLevel);
  const curObject = curData[indicatorIndex];

  function roundto1dp(num) {
    return Number(new Decimal(num).toFixed(1));
  }

  const curDataObject = curData.find((obj) => obj.iID === incomeLevel);
  console.log('curData ', curData);
  console.log(curDataObject);

  function getAnnotationString() {
    //
    if (!incomeSelectActive) {
      return '';
    }

    // const timeframeString = timeframe === 'annual' ? 'year' : 'week';
    const earnLessValue = earnLess[indicatorIndex];
    const earnMoreValue = earnMore[indicatorIndex];

    const earnLessTotal = Math.round(totalInGroup * (earnLessValue / 100));
    const earnMoreTotal = Math.round(totalInGroup * (earnMoreValue / 100));

    const roundedLess = Math.abs(
      Math.round(earnLessTotal / 1000) * 1000,
    ).toLocaleString();
    const roundedMore = Math.abs(
      Math.round(earnMoreTotal / 1000) * 1000,
    ).toLocaleString();

    return (
      <div className="annoation-helper">
        {curObject.dataStatus} Approximately <strong>{roundedLess}</strong> earn
        less than you, and <strong>{roundedMore}</strong> earn more than you.
      </div>
    );
  }

  function getStandardError() {
    if (!incomeSelectActive) {
      return '';
    }

    if (curObject.dataStatus === '*') {
      return (
        <div className="standard-error">
          <strong>NOTE:</strong> {standardError}
        </div>
      );
    }

    if (curObject.dataStatus === '**') {
      return (
        <div className="standard-error">
          <strong>NOTE:</strong> {standardErrorHigh}
        </div>
      );
    }

    return '';
  }

  return <>{getStandardError()}</>;
}
